'use strict'

define ['./applications.css'], () ->
  ($scope, $rootScope, $http, $state, $q, RentappService, $cookies, $timeout, MIN_DESKTOP_WIDTH, activeApplications, archivedApplications) ->
    $scope.tab_state = 'active'

    $scope.active_applications = activeApplications.objects
    $scope.archived_applications = archivedApplications.objects

    $scope.active_total_count = activeApplications.meta.total_count
    $scope.archived_total_count = archivedApplications.meta.total_count

    $scope.mobile_view = window.innerWidth < 768

    $scope.toggle_tab_state = (state) ->
      $scope.tab_state = state
      $rootScope.$broadcast('switched-tab-state', { state: state })

    $scope.pagination_options =
      applications__is_removed: false
      applications__is_archived: $scope.tab_state == 'archived'
      for_datatable: true

    RentappService.getMe().then (user) ->
      $scope.dashboardView = if user.landlord then "landlord" else "applicant"

    $scope.reset = () -> 
      $scope.search_term = ''        

    $scope.search = (search_term) ->
      $rootScope.$broadcast("mobile-app-search", {search_term: search_term, state: $scope.tab_state})

    $scope.$on 'show-action-bar', (event, data) ->
      $scope.slide_bottom = true

    $scope.$on 'hide-action-bar', (event, data) ->
      $scope.slide_bottom = false



// WEBPACK FOOTER //
// ./components/dashboard/applications/applications.coffee